import { Link, useLocation, useNavigate } from "react-router-dom";

import NotificationButton from "components/layout/notification/NotificationButton";
import FullscreenButton from "components/layout/FullscreenButton";
import FunctionalButton from "components/layout/FunctionalButton";
import OrganizationSwitcher from "components/layout/navbar/OrganizationSwitcher";
import FleetLogoutButton from "components/layout/navbar/FleetLogoutButton";

import defaultUserIcon from "assets/imgs/defaultUserIcon.jpg";
import { ReactComponent as LanguageIcon } from "assets/svgs/Language.svg";
import { ReactComponent as GridIcon } from "assets/svgs/navbar/Grid.svg";
import { HAS_NOTIFICATIONS, HAS_FULLSCREEN } from "lib/consts/flags";

const TopBar = ({ title, navigationItems = [] }) => {
    const routeLocation = useLocation();
    const navigate = useNavigate();

    return (
        <div className="flex h-topBar w-full  items-center justify-between p-6">
            <h2 className="text-h2 h-9 font-bold uppercase leading-[normal] md:leading-[inherit] tablet:leading-[inherit]">
                {title}
            </h2>
            <div className="flex h-9 max-w-[28.125rem]  items-center justify-between space-x-6 text-h4l text-black60">
                {navigationItems.map((navigate, id) => (
                    <Link
                        key={id}
                        className={`text-h4 md:text-h4s tablet:text-h4m ${routeLocation.pathname === navigate.to ? "text-white" : ""
                            }`}
                        to={navigate.to}
                    >
                        {navigate.title}
                    </Link>
                ))}
            </div>
            <div className="flex max-w-[21.875rem]  items-center justify-between space-x-4">
                <div className="flex items-center space-x-4">
                    <FunctionalButton
                        icon={<GridIcon className="h-6 w-6" />}
                        className="h-9 w-9 text-black60 hover:text-white"
                        hoverText="Dashboard"
                        onClick={() => navigate("/fleet/dashboard")}
                    />
                    <OrganizationSwitcher />
                    {HAS_NOTIFICATIONS && <NotificationButton />}
                    {HAS_FULLSCREEN && <FullscreenButton />}
                    <FleetLogoutButton />
                </div>
                {/* <div className="flex  items-center justify-between space-x-2">
                    <p className="md:hidden">Andy Chan</p>
                    <img className="w-9 rounded-full" src={defaultUserIcon} alt="User icon" />
                </div> */}
            </div>
        </div>
    );
};

export default TopBar;
